import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const DEFAULT_SUPPORT_PHONE = '+55 (11) 94328-5904';

const buildWhatsAppLink = (supportPhone) => {
  const digitsOnly = (supportPhone || '').replace(/\D/g, '');

  return `https://wa.me/${digitsOnly}`;
};

/**
 * Mensagem de bloqueio + CTA de contato com o suporte via WhatsApp.
 * Reutilizada tanto na tela cheia de bloqueio quanto dentro do modal de
 * troca de número (RF04), evitando duplicar o texto e o link.
 */
const SupportContactMessage = ({ supportPhone }) => {
  const { t } = useTranslation();
  const phone = supportPhone || DEFAULT_SUPPORT_PHONE;

  return (
    <>
      <Typography align="center" variant="h6">
        {t('For your security, SMS sending was temporarily blocked due to repeated attempts')}
      </Typography>
      <Typography align="center">
        {t('Please contact our support team via WhatsApp or phone to continue {{phone}}', { phone })}
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        component="a"
        href={buildWhatsAppLink(phone)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('Contact support on WhatsApp')}
      </Button>
    </>
  );
};

export default SupportContactMessage;
